import React from 'react';
import { Check } from 'lucide-react';
import { TapeBadge } from './TapeBadge';
export function Services() {
  const services = [{
    title: 'THE BASIC',
    price: '$149',
    desc: 'Standard deep clean to get you grilling again.',
    features: ['Grates & Flavorizer Bars', 'Burner Tubes Cleaned', 'Firebox Scraped', 'Exterior Degreased & Polished'],
    popular: false
  }, {
    title: 'THE FULL SEND',
    price: '$249',
    desc: 'Our premium service. Looks like it just left the factory.',
    features: ['Everything in Basic', 'Deep Interior Detail', 'Steam Sanitization', 'Rust Treatment', 'Protective Sealant Applied'],
    popular: true
  }, {
    title: 'COMMERCIAL',
    price: 'QUOTE',
    desc: 'For restaurants, HOAs, and property managers.',
    features: ['Multi-Grill Discounts', 'Recurring Maintenance', 'Health Code Compliance', 'Priority Scheduling'],
    popular: false
  }];
  return <section id="services" className="relative bg-otter-bone py-24" data-id="element-271">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0IiBoZWlnaHQ9IjQiPgo8cmVjdCB3aWR0aD0iNCIgaGVpZ2h0PSI0IiBmaWxsPSIjZmZmIi8+CjxyZWN0IHdpZHRoPSIxIiBoZWlnaHQ9IjEiIGZpbGw9IiNjY2MiLz4KPC9zdmc+')] opacity-50" data-id="element-272" />

      <div className="container relative z-10 mx-auto px-4" data-id="element-273">
        <div className="mb-16 text-center" data-id="element-274">
          <h2 className="font-display text-6xl tracking-tighter text-otter-black sm:text-8xl" data-id="element-275">
            WHAT WE{' '}
            <span className="text-otter-cyan text-stroke-black" data-id="element-276">DO</span>
          </h2>
          <TapeBadge text="CHOOSE YOUR WEAPON" color="black" rotation={2} className="mt-4 bg-otter-black text-otter-bone" data-id="element-277" />
        </div>

        <div className="grid gap-8 lg:grid-cols-3" data-id="element-278">
          {services.map((service, idx) => <div key={idx} className={`relative flex flex-col border-4 border-otter-black bg-otter-black p-8 text-otter-bone transition-transform hover:-translate-y-2 ${service.popular ? 'scale-105 shadow-brutal-cyan lg:-translate-y-4' : 'shadow-brutal'}`} data-id="element-279">
              {service.popular && <div className="absolute -right-4 -top-6 z-20" data-id="element-280">
                  <TapeBadge text="MOST POPULAR" color="blaze" rotation={6} data-id="element-281" />
                </div>}

              <div className="mb-6 border-b-2 border-otter-bone/20 pb-6" data-id="element-282">
                <h3 className="font-display text-4xl tracking-wider text-otter-cyan" data-id="element-283">
                  {service.title}
                </h3>
                <div className="mt-2 font-display text-5xl" data-id="element-284">
                  {service.price}
                </div>
                <p className="mt-4 font-body text-otter-bone/70" data-id="element-285">
                  {service.desc}
                </p>
              </div>

              <ul className="mb-8 flex-grow space-y-4" data-id="element-286">
                {service.features.map((feature, fIdx) => <li key={fIdx} className="flex items-start gap-3" data-id="element-287">
                    <Check className="mt-1 shrink-0 text-otter-cyan" size={20} data-id="element-288" />
                    <span className="font-body text-lg" data-id="element-289">{feature}</span>
                  </li>)}
              </ul>

              <a href="#contact" className={`mt-auto block w-full border-4 py-4 text-center font-display text-2xl tracking-wider transition-colors ${service.popular ? 'border-otter-cyan bg-otter-cyan text-otter-black hover:bg-transparent hover:text-otter-cyan' : 'border-otter-bone bg-transparent text-otter-bone hover:bg-otter-bone hover:text-otter-black'}`} data-id="element-290">
                BOOK IT
              </a>
            </div>)}
        </div>
      </div>
    </section>;
}